import {MainVideoState} from "../definitions/MainVideoState";

export const scrollFinished = (state: MainVideoState) => {
    state.shouldUseHighResPreview = true;
};
